<template>
  <div class="insurancesolutionMain">
        <div class="solttionCon">
          <div class="solttionConItem">
            <div class="solttionConHead">
              <ul>
                <li></li>
                <li>行业痛点</li>
              </ul>
            </div>
            <div class="solutionList">
                <ul v-if="difficultList.length>0">
                  <li v-for="item in difficultList">
                      <div><img :src="item.img"></div>
                      <dl>
                        <dt>{{item.title}}</dt>
                        <dd>{{item.content}}</dd>
                      </dl>
                  </li>
                </ul>
            </div>
          </div>
          <div class="solttionConItem">
            <div class="solttionConpor">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>解决方案</li>
                </ul>
              </div>
              <div class="programBox">
                <p>
                      在保险行业，可凭借智签电子签约平台签订《投保须知》、《保险条款》、《服务协议》、《保险代理合同》等相关文件，并通过技术手段的运用，固化保险销售“双录”中生成的电子数据的原始性、真实性，并证明其关联关系，从而证明保险销售行为事实。结合司法联盟链上各家机构的公信力，增强电子证据证明力，并在纠纷发生时，出具相应的报告，保证电子数据可以作为证据被法院、仲裁所采信。
                </p>
                <p>
                      保险行业解决方案提供实名认证、电子签章、电子数据存证、数据密文托管、在线公证、在线鉴定等多元化的在线服务。并为保险企业的合规建设，风险控制提供有力支撑，从而增强用户信任度，加快合规进度，全面提升企业核心竞争力。
                </p>
              </div>

            </div>
          </div>
           <div class="solttionConItem">
              <div class="solttionConHead">
                <ul>
                  <li></li>
                  <li>特色保障</li>
                </ul>
              </div>
              <div class="guaranteeList">
                <ul>
                  <li v-for="item in guaranteeList">
                    <div>
                        <img :src="item.img" class="BigImg">
                        <span class="icon" v-bind:style="{backgroundImage:'url(' + item.icon + ')'}"></span>
                    </div>
                    <dl>
                      <dt><span>{{item.title}}</span></dt>
                      <dd>{{item.content}}</dd>
                    </dl>
                  </li>
                </ul>
              </div>
           </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      difficultList:[
        {
          img:require("../../../assets/images/solution/cphlwh_icon.png"),
          title:"产品互联网化",
          content:"近些年来，大量的保险业务由线下转至线上，纸质合同耗时长、效率低。"
        },
        {
          img:require("../../../assets/images/solution/htgln_icon.png"),
          title:"合同管理难",
          content:"大量的纸质合同，存储成本高，安全性差，管理困难。"
        },
        {
          img:require("../../../assets/images/solution/jfdjjn_icon.png"),
          title:"纠纷解决难",
          content:"理赔、销售纠纷一直是保险行业的突出问题，大量的纠纷缺少关键的业务流程数据，导致解决困难。"
        },
        {
          img:require("../../../assets/images/solution/jyhgyq_icon.png"),
          title:"行业合规要求",
          content:"2017年，保监会下发《保险销售行为可回溯管理暂行办法》，明确规定保险销售进行双录并安全存储。"
        }
      ],
      guaranteeList:[
        {
          img:require("../../../assets/images/solution/legal_img.png"),
          icon:require('../../../assets/images/solution/legal_nor_icon.png.png'),
          title:"法律效力",
          content:"对接公安部、工商局、银联数据库进行实名认证，保障合同主体可信，采用数字证书，可信时间源等方式，保障合同司法效力。"
        },
        {
          img:require("../../../assets/images/solution/jbzx_img.png"),
          icon:require('../../../assets/images/solution/jdcb_nor_icon.png'),
          title:"降本增效",
          content:"减少线下签署环节，减少人力、邮寄、纸质合同及管理成本。达到大幅度提高人力资源管理工作的效率并降低成本的目的。"
        },
        {
          img:require("../../../assets/images/solution/judicial_img.png"),
          icon:require('../../../assets/images/solution//judicial_nor_icon.png'),
          title:"司法保障",
          content:"司法联盟链同步至多家公证处、司法鉴定机构，仲裁机构以及互联网法院，多方参与共识，保证电子数据作为证据的司法证明能力。"
        },
        {
          img:require("../../../assets/images/solution/data_img.png"),
          icon:require('../../../assets/images/solution/data_nor_icon.png.png'),
          title:"数据安全",
          content:"采用杂凑算法、非对称加密算法、分布式存储、区块链技术等多种技术保障电子数据的真实性、安全性及不可篡改。"
        },
      ],
    }
  }
}
</script>
<style lang="scss" >
.insurancesolutionMain{
    width:100%;
    .solttionCon{
      .solttionConItem{
        width:1180px;
      padding-bottom:40px;
       margin:0 auto;
        .solttionConHead{
          width: 100%;
          overflow: hidden;
          padding-top: 40px;
          padding-bottom: 30px;
          li{
            float: left;
            line-height: 18px;
          }
          li:nth-child(1){
            height: 18px;
            width:4px;
            background: #B41C2E;
            margin-right: 10px;
          }
          li:nth-child(2){
            font-family: 'PingFangSC-Light';
            font-size: 18px;
            color: #464646;
          }
        }
        .solutionList{
          width:100%;
          height: 190px;
          li{
            width: calc((100% - 60px) / 4);
            height: 190px;
            float: left;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            margin-right: 20px;
            padding:20px;
            box-sizing: border-box;
            border: 1px solid rgb(235,235,235);
            div{
              text-align: right;
              img{
                width:48px;
                height: auto;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-bottom: 10px;
              }
              dd{
                font-size: 13px;
                color: #787878;
                line-height: 19px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
             border-color: #fff;
          }
        }
        .programBox{
          width:100%;
          overflow: hidden;
          p{
              font-size: 14px;
              color: #787878;
              text-align: justify;
              line-height: 26px;
              text-indent: 2em;
          }
          p:nth-child(2){
            margin-top: 20px;
          }
        }
        .solttionConpor{
          max-width: 1180px;
          margin:0 auto;
        }
        .guaranteeList{
          width:100%;
          height: 328px;
          li{
            width: calc((100% - 78px) / 4);
            height: 328px;
            float: left;
            margin-right: 26px;
            box-sizing: border-box;
            padding:2px;
            border: 1px solid rgb(235,235,235);
            div{
              width:100%;
              height: 160px;
              position: relative;
              .BigImg{
                width:100%;
                height: 100%;
              }
              .icon{  
                position: absolute;
                top:50%;
                left:50%;
                margin-top:-19px;
                margin-left: -20px;
                width:40px;
                height: 38px;
                background-size:100% 100%;
              }
            }
            dl{
              dt{
                font-size: 18px;
                color: #464646;
                font-weight: 550;
                margin-top:11px;
                margin-bottom: 15px;
                text-align: center;
                span{
                  display: inline-block;
                  padding-bottom: 6px;
                  border-bottom: 2px solid #B4B4B4;
                }
              }
              dd{
                box-sizing: border-box;
                padding:0 16px;
                font-size: 14px;
                color: #787878;
                line-height: 21px;
                text-align: justify;
              }
            }
          }
          li:last-child{
            margin-right: 0;
          }
          li:hover{
            box-shadow: 0 2px 12px 0 rgba(0,0,0,0.20);
            border-color: #fff;
            dl dt span{
              border-color:#686868;
            }
          }
          li:nth-child(1):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/legal_hov_icon.png')!important;
            }
          }
          li:nth-child(2):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/jdcb_hov.png')!important;
            }
          }
          li:nth-child(3):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/judicial_hov_icon.png.png')!important;
            }
          }
          li:nth-child(4):hover{
            div .icon{
              background-image:url('../../../assets/images/solution/data_hov_icon.png')!important;
            }
          }
        }
      }
      .solttionConItem:nth-child(2){
        width: 100%;
        background: #F3F2F2;
      }
    }
  }
</style>
